/* eslint-disable camelcase */
import { IPerformanceFilter, IStatisticsParams } from '../../_models/superAdmin/dashboardInterface'
import { get } from '../apiServices'

export const getSuperAdminDashboard = async () => {
  const response = await get('/super-admin/dashboard')
  return response
}
export const getSuperAdminPerformance = async (performanceFilters: IPerformanceFilter) => {
  const response = await get('/super-admin/performance', performanceFilters)
  return response
}
export const getSuperAdminDashboardBusiness = async () => {
  const response = await get('/super-admin/business-list')
  return response
}

export const getSuperAdminStatistics = async (params: IStatisticsParams) => {
  const response = await get('super-admin/statistics', params)
  return response
}
